import request from '@/util/request';
import qs from 'qs';

export const getPageList = (params, options) =>
  request.get('/api/v4ward/decorate/mini/manage/page', Object.assign({}, options, { params }));

export const add = (params, options) =>
  request.post('/api/v4ward/decorate/mini/manage/create', params, options, { 'Content-Type': 'application/json' });

export const remove = (params, options) =>
  request.post('/api/v4ward/decorate/mini/manage/remove', qs.stringify(params), options, { 'Content-Type': 'application/json' });

export const update = (params, options) =>
  request.post('/api/v4ward/decorate/mini/manage/update', params, options, { 'Content-Type': 'application/json' });

// 获取指定小程序指定页面的样式配置
export const getPageData = (params, options) =>
  request.get('/api/v4ward/decorate/mini/custom/getDecorate', Object.assign({}, options, { params }));

// 保存指定小程序指定页面的样式配置
export const savePageData = (params, options) =>
  request.post('/api/v4ward/decorate/mini/custom/submitDecorate', params, options, { 'Content-Type': 'application/json' });
